import {ModuleRenderProps} from "../../../../core/component/module/module.root";
import {HeaderDRERealized} from "../component/header.dre-realized";
import React, {useEffect, useState} from "react";
import {DreRowDto} from "../../../../domain/dto/dre-row.dto";
import {Button, Col, Divider, Form, Row, Select, Space} from "antd";
import {useCompetenceRepository} from "../../../../domain/repository/competence.repository";
import {CompetenceEntity} from "../../../../domain/entity/competence.entity";
import {getSorter} from "../../../../core/util/sort-array.util";
import {DownloadOutlined, SearchOutlined} from "@ant-design/icons";
import {useFirmRepository} from "../../../../domain/repository/firm.repository";
import {FirmEntity} from "../../../../domain/entity/firm.entity";
import {CostCenterEntity} from "../../../../domain/entity/cost-center.entity";
import {useDocumentFormatter} from "../../../service/document.formatter.service";
import {DreList} from "../../../component/dre-list";
import {BudgetEntity} from "../../../../domain/entity/budget.entity";
import {useBudgetRepository} from "../../../../domain/repository/budget.repository";
import {useCostCenterRepository} from "../../../../domain/repository/account.repository";

export function ReportDreBudgeted(props: ModuleRenderProps) {
  const [form] = Form.useForm();
  const [data, setData] = useState<DreRowDto[]>([]);
  const [competences, setCompetences] = useState<CompetenceEntity[]>([]);
  const [budgets, setBudgets] = useState<BudgetEntity[]>([]);
  const [firms, setFirms] = useState<FirmEntity[]>([]);
  const [costCenters, setCostCenters] = useState<CostCenterEntity[]>([]);

  const { formatCNPJ } = useDocumentFormatter();
  const competenceRepo = useCompetenceRepository();
  const budgetRepo = useBudgetRepository();
  const firmRepo = useFirmRepository();
  const costCenterRepo = useCostCenterRepository();

  function loadParams() {
    firmRepo.findAll().then(res => setFirms(res.data));
    competenceRepo.findAll().then(res => setCompetences(res.data));
    costCenterRepo.findAll().then(res => setCostCenters(res.data));
  }

  function loadCostCenters() {
    if (form.getFieldValue('firmId')) {
      firmRepo.listCostCenters(form.getFieldValue('firmId'))
        .then(res => setCostCenters(res.data));
    }
  }

  function loadBudgets() {
    form.resetFields(['budgetId']);
    if (form.getFieldValue('competenceId')) {
      budgetRepo.getActiveVersions(form.getFieldValue('competenceId'))
        .then(res => setBudgets(res.data));
    }
  }

  useEffect(() => {
    loadParams();
  }, [1]);

  function loadData(args: any) {
    const { budgetId, firmId, costCenterId } = args;
    budgetRepo
      .getDreResult(budgetId, firmId, costCenterId, args.transform)
      .then(res => !args.transform && setData(res.data));
  }

  function getCompetenceOpts() {
    return competences
      .sort(getSorter<CompetenceEntity>('year'))
      .map(item => ({
        label: item.year,
        value: item.id
      }))
  }

  function getFirmOpts() {
    return firms.sort(getSorter<FirmEntity>('name'))
      .map(item => ({
        label: `${item.name} - ${formatCNPJ(item.document)}`,
        value: item.id
      }))
  }

  function getCostCenterOpts() {
    return costCenters.sort(getSorter<CostCenterEntity>('code'))
      .map(item => ({
        label: `${item.code} - ${item.name}`,
        value: item.id as number,
      }))
  }

  function getBudgetOpts() {
    return budgets.sort(getSorter<BudgetEntity>('version'))
      .map(item => ({
        label: `${item.version}`,
        value: item.id as number,
      }))
  }

  return (
    <>
      <HeaderDRERealized title={'DRE - Orçada'} />
      <Divider />
      <Form form={form} layout={'vertical'} onFinish={loadData} size={'middle'} >
        <Row gutter={12}>
          <Col span={6}>
            <Form.Item name={'competenceId'} label={'Competência'} rules={[{ required: true }]}>
              <Select allowClear options={getCompetenceOpts()} onSelect={() => loadBudgets()} />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name={'budgetId'} label={'Versão do orçamento'} rules={[{ required: true }]}>
              <Select allowClear options={getBudgetOpts()} />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name={'firmId'} label={'Filial'}>
              <Select allowClear options={getFirmOpts()} onSelect={(val: number) => loadCostCenters()} />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name={'costCenterId'} label={'Centro de Custo'}>
              <Select allowClear options={getCostCenterOpts()} />
            </Form.Item>
          </Col>
        </Row>
        <div style={{display: 'flex', justifyContent: 'flex-end'}}>
          <Space>
            <Form.Item name={'transform'}>
              <Button
                icon={<SearchOutlined />}
                type={'primary'}
                size={'middle'}
                loading={budgetRepo.loading}
                onClick={() => {
                  form.setFields([{name: 'transform', value: false}]);
                  form.submit();
                }}>
                Pesquisar
              </Button>
            </Form.Item>
            <Form.Item name={'transform'}>
              <Button
                icon={<DownloadOutlined />}
                size={'middle'}
                onClick={() => {
                  form.setFields([{name: 'transform', value: true}]);
                  form.submit();
                }}>
                CSV
              </Button>
            </Form.Item>
          </Space>
        </div>
      </Form>
      <Divider style={{marginTop: 0}} />
      <DreList data={data} loading={budgetRepo.loading} />
    </>
  )
}
